export default __webpack_public_path__ + "static/media/article_img_0.e163a262.jpeg";